var Header = {
    prevScroll:0,
    current_sousMenu:-1,
    init:function(){
        $(window).on("scroll", function(){
            Header.scroll();
        });
        setTimeout(function(){
            
            $(".nav-main .menu-item-has-children").mouseenter(function(){
                Header.open_sousMenu_desktop($(this).index());
            }).mouseleave(function(){
                Header.close_sousMenu_desktop();
            });

            
            $(".menu-desktop").mouseenter(function(){
                Header.open_sousMenu_desktop(Header.current_sousMenu);
            }).mouseleave(function(){
                Header.close_sousMenu_desktop();
            });

        },200);
    },
    open_sousMenu_desktop:function(id){
        Header.current_sousMenu = id;
        $(".header").addClass("menu-desktop-open");
        $(".menu-desktop").addClass("open");
        
        var _h_dest = 0;

        $(".menu-desktop .level-0 > .menu-item").each(function(i){
            if(i == id){
                $(this).find(".level-1").addClass("open");
                _h_dest = $(this).find(".level-1").outerHeight();
            }else{
                $(this).find(".level-1").removeClass("open");
            }
        });

        $(".nav-main .level-0 > .menu-item").each(function(i){
            if(i == id){
                $(this).addClass("hover");
            }else{
                
                $(this).removeClass("hover");
            }
        });

        $(".menu-desktop .susy-container").css({height:_h_dest + "px"});

    },
    close_sousMenu_desktop:function(){
        $(".header").removeClass("menu-desktop-open");
        $(".menu-desktop").removeClass("open");

        $(".nav-main .level-0 > .menu-item").removeClass("hover");

    },
    scroll:function(){
        if(Header.prevScroll >  window.scrollY || window.scrollY < 100){
            $("header").removeClass("scrolled");
        }else{
            $("header").addClass("scrolled");
        }

        Header.prevScroll = window.scrollY;
    }
}
Header.init();